import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faTrashAlt } from '@fortawesome/pro-solid-svg-icons';
import confirm from 'components/confirm';

import Errors from 'components/form/errors';
import ManagedInput from 'components/form/managed_input';
import WysiwygEditor from 'components/form/wysiwyg_editor';

export default class CustomDetails extends React.Component {
  static propTypes = {
    card: PropTypes.shape({
      id: PropTypes.number,
      cardType: PropTypes.string.isRequired,
      content: PropTypes.string,
      title: PropTypes.string,
      subtitle: PropTypes.string,
      visibleToClient: PropTypes.bool.isRequired
    }).isRequired,
    onClose: PropTypes.func.isRequired,
    onRemove: PropTypes.func,
    onSave: PropTypes.func.isRequired,
    onUploadImage: PropTypes.func
  }

  state = {
    card: this.props.card,
    changes: false,
    errors: null,
    saving: false
  }

  disableSave = () => {
    return this.state.saving || !this.state.changes;
  }

  handleDelete = () => {
    const message = 'Are you sure you want to delete this custom tile?';
    confirm(message, {
      buttonLabel: 'Delete tile',
      buttonStyle: 'danger',
      title: `Delete tile?`
    }).then(() => {
      this.setState({ saving: true });

      this.props.onRemove(this.props.card.id)
        .then(() => this.props.onClose());
    });
  }

  handleChange = (fieldValue) => {
    this.setState(({ card }) => ({ card: { ...card, ...fieldValue }, changes: true }));
  }

  handleEditorChange = (content) => {
    this.setState(({ card }) => ({ card: { ...card, content }, changes: true }));
  }

  handleSave = () => {
    this.setState({ errors: null, saving: true });

    this.props.onSave(this.state.card)
      .then(() => this.props.onClose())
      .catch(errors => this.setState({ errors, saving: false }));
  }

  showDeleteButton = () => {
    return this.props.onRemove && this.props.card.id;
  }

  renderDeleteButton() {
    if (this.showDeleteButton()) {
      return (
        <div
          className="btn muted-button d-inline-block mr-1"
          name="remove-task"
          onClick={this.handleDelete}
        >
          <FontAwesomeIcon className="trash-icon" icon={faTrashAlt} />
          <span className="ml-3">Delete Tile</span>
        </div>
      );
    }
  }

  renderTextEditor() {
    return (
      <div className="form-group required">
        <label className="control-label">Body *</label>
        <div className="form-input-container">
          <WysiwygEditor
            content={this.props.card.content}
            onChange={this.handleEditorChange}
            onUploadImage={this.props.onUploadImage}
          />
        </div>
      </div>
    );
  }

  renderTextField(name, required, maxLength) {
    return (
      <div className={`form-group ${required && 'required'}`}>
        <label className="control-label text-capitalize">{name} {required && '*'}</label>
        <div className="form-input-container">
          <ManagedInput
            className="form-control"
            maxLength={maxLength}
            name={name}
            type="text"
            value={this.state.card[name]}
            onChange={this.handleChange}
          />
        </div>
      </div>
    );
  }

  renderCTAs() {
    return (
      <div className="pull-right">
        {this.renderDeleteButton()}
        <button className="btn btn-cancel" name="cancel" onClick={this.props.onClose}>Cancel</button>
        <button
          className="btn btn-save left-buffer-md"
          disabled={this.disableSave()}
          name="save"
          onClick={this.handleSave}
        >
          {this.state.saving ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Save'}
        </button>
      </div>
    );
  }

  render() {
    const { errors } = this.state;

    return (
      <div className="form">
        {errors && <Errors errors={errors} />}
        {this.renderTextField('title', true, 25)}
        {this.renderTextField('subtitle', false, 50)}
        {this.renderTextEditor()}
        {this.renderCTAs()}
      </div>
    );
  }
}
